export default __webpack_public_path__ + "static/media/fourthimgd.da778452.png";